import { Box, Button, InputLabel, Stack, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import useResponsive from "../../hooks/useResponsive";
import ModalContainer from "../ui-elements/modal-container";
import { CloseDrawerIcon } from "../ui-elements/svg-icons";
import { useNavigate } from "react-router-dom";
import { PATH_DASHBOARD, PATH_NEWSFEED } from "../../routes/path";

export const OnboardingMainModal = ({
  open,
  modal_handler,
}: {
  open: boolean;
  modal_handler: () => void;
}) => {
  const theme = useTheme();
  const navigate = useNavigate();

  return (
    <ModalContainer
      sx={{
        borderRadius: "16px",
      }}
      size={"xs"}
      openModal={open}
      fullWidth={true}
      handleModal={() => {}}
    >
      <Box sx={{ background: "#fff", py: 2, px: 4, borderRadius: "16px" }}>
        <Stack direction={"row"} justifyContent={"end"}>
          <Button sx={{ minWidth: 10 }} onClick={modal_handler}>
            <CloseDrawerIcon />
          </Button>
        </Stack>
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <img
            src={"/assets/icons/onboarding/caution-icon.png"}
            style={{ width: 48, height: 48, marginTop: 10, marginBottom: 22 }}
          />
          <Typography variant="h5" sx={{ color: "#0A0B0A", fontWeight: 600 }}>
            Don't Skip!
          </Typography>
          <Typography
            variant="body2"
            sx={{
              color: "#7991A4",
              fontWeight: 500,
              lineHeight: 1.5,
              textAlign: "center",
            }}
          >
            Completing the onboarding helps us tailor your experience, ensuring
            you receive personalized reports and updates from your community.
            Stay informed on what matters most to you!
          </Typography>
        </Box>
        <Box
          sx={{
            width: "90%",
            display: "flex",
            flexDirection: "column",
            gap: 2,
            my: 3,
            mx: "auto",
          }}
        >
          <Button
            variant="contained"
            color="primary"
            sx={{
              borderRadius: 40,
              boxShadow: "none",
            }}
            onClick={modal_handler}
          >
            Get started
          </Button>
          <Button
            variant="contained"
            sx={{
              borderRadius: 40,
              background: "#CCCBCB",
              color: "#000",
              boxShadow: "none",
            }}
            onClick={() => {
              modal_handler();
              navigate(PATH_NEWSFEED.root);
            }}
          >
            Skip
          </Button>
        </Box>
      </Box>
    </ModalContainer>
  );
};

export const OnboardingSkipModal = ({
  open,
  modal_handler,
}: {
  open: boolean;
  modal_handler: () => void;
}) => {
  const theme = useTheme();
  const navigate = useNavigate();

  return (
    <ModalContainer
      sx={{
        borderRadius: "16px",
      }}
      size={"xs"}
      openModal={open}
      fullWidth={true}
      handleModal={() => {}}
    >
      <Box sx={{ background: "#fff", py: 2, px: 4, borderRadius: "16px" }}>
        <Stack direction={"row"} justifyContent={"end"}>
          <Button sx={{ minWidth: 10 }} onClick={modal_handler}>
            <CloseDrawerIcon />
          </Button>
        </Stack>
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <img
            src={"/assets/icons/onboarding/notice-green.png"}
            style={{ width: 48, height: 48, marginTop: 10, marginBottom: 22 }}
          />
          <Typography
            variant="h5"
            sx={{ color: "#0A0B0A", fontWeight: 600, textAlign: "center" }}
          >
            Your account setup is almost complete
          </Typography>
          <Typography
            variant="body2"
            sx={{
              color: "#7991A4",
              fontWeight: 500,
              lineHeight: 1.5,
              textAlign: "center",
            }}
          >
            To complete your account setup, please upload a valid voter's card
            for verification. You can continue the process in your profile.
          </Typography>
        </Box>
        <Box
          sx={{
            width: "90%",
            display: "flex",
            flexDirection: "column",
            gap: 2,
            my: 3,
            mx: "auto",
          }}
        >
          <Button
            variant="contained"
            color="primary"
            sx={{
              borderRadius: 40,
              boxShadow: "none",
            }}
            onClick={() => {
              modal_handler();
              navigate(PATH_NEWSFEED.root);
            }}
          >
            Continue
          </Button>
        </Box>
      </Box>
    </ModalContainer>
  );
};

export const OnboardingVerificationModal = ({
  open,
  modal_handler,
}: {
  open: boolean;
  modal_handler: () => void;
}) => {
  const theme = useTheme();
  const navigate = useNavigate();

  return (
    <ModalContainer
      sx={{
        borderRadius: "16px",
      }}
      size={"xs"}
      openModal={open}
      fullWidth={true}
      handleModal={() => {}}
    >
      <Box sx={{ background: "#fff", py: 2, px: 4, borderRadius: "16px" }}>
        <Stack direction={"row"} justifyContent={"end"}>
          <Button sx={{ minWidth: 10 }} onClick={modal_handler}>
            <CloseDrawerIcon />
          </Button>
        </Stack>
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <img
            src={"/assets/icons/onboarding/notice-green.png"}
            style={{ width: 48, height: 48, marginTop: 10, marginBottom: 22 }}
          />
          <Typography variant="h5" sx={{ color: "#0A0B0A", fontWeight: 600 }}>
            Verification ongoing
          </Typography>
          <Typography
            variant="body2"
            sx={{
              color: "#7991A4",
              fontWeight: 500,
              lineHeight: 1.5,
              textAlign: "center",
            }}
          >
            Thank you for completing your profile! Your information is now being
            verified. You’ll receive a notification shortly once the process is
            complete and your account is fully activated.
          </Typography>
        </Box>
        <Box
          sx={{
            width: "90%",
            display: "flex",
            flexDirection: "column",
            gap: 2,
            my: 3,
            mx: "auto",
          }}
        >
          <Button
            variant="contained"
            color="primary"
            sx={{
              borderRadius: 40,
              boxShadow: "none",
            }}
            onClick={() => {
              modal_handler();
              navigate(PATH_DASHBOARD.root);
            }}
          >
            Continue
          </Button>
        </Box>
      </Box>
    </ModalContainer>
  );
};
